import { render, staticRenderFns } from "./CollapsibleBlock.vue?vue&type=template&id=c0f4d5b0&scoped=true&"
import script from "./CollapsibleBlock.vue?vue&type=script&lang=js&"
export * from "./CollapsibleBlock.vue?vue&type=script&lang=js&"
import style0 from "./CollapsibleBlock.vue?vue&type=style&index=0&id=c0f4d5b0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0f4d5b0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\agent\\_work\\11\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c0f4d5b0')) {
      api.createRecord('c0f4d5b0', component.options)
    } else {
      api.reload('c0f4d5b0', component.options)
    }
    module.hot.accept("./CollapsibleBlock.vue?vue&type=template&id=c0f4d5b0&scoped=true&", function () {
      api.rerender('c0f4d5b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layout/CollapsibleBlock.vue"
export default component.exports